import classNames from 'classnames'
import * as React from 'react'

import { TableAlign, TableHead, TableHeader, TableHeaderSortable } from '../../components/Table'
import { FinancialsColumnDefinition, FinancialsRowDataType } from '../../components/financials-table/types'
import { SortByShape } from '../../hooks/use-sort-data'
import { SortDirection } from '../../types'
import { RevenueColumnsType } from './types'

type Props = {
  columns: RevenueColumnsType['columns']
  unit: string
  sort: SortByShape<FinancialsColumnDefinition<FinancialsRowDataType>>
  onSortChange: (column: FinancialsColumnDefinition<FinancialsRowDataType>) => void
}

export function RevenueTableHead({ columns, unit, sort, onSortChange }: Props) {
  const handleChangeSort = (column: FinancialsColumnDefinition<FinancialsRowDataType>) => {
    const shouldRemoveOrder = sort.direction === SortDirection.Descending && column === sort.column
    if (shouldRemoveOrder) {
      onSortChange('order' as unknown as FinancialsColumnDefinition<FinancialsRowDataType>)
    } else {
      onSortChange(column)
    }
  }

  return (
    <TableHead>
      <TableHeader align={TableAlign.Left}>
        Currency: <span className={classNames({ 'font-medium': unit !== 'USD' })}>{unit}</span>
      </TableHeader>
      {columns.map((column) => (
        <TableHeaderSortable
          key={column.id}
          align={column.align}
          className={column.className}
          isActive={column.id === sort.column?.id}
          direction={sort.direction}
          onClick={() => handleChangeSort(column)}
        >
          {column.name}
        </TableHeaderSortable>
      ))}
    </TableHead>
  )
}
